import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { screenResize } from './actions';
import './css/bootswatch.css';
import './css/index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

document.title = 'Explorer';

export const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);

window.addEventListener('resize', () => {
    store.dispatch(screenResize(window.innerWidth));
});

ReactDOM.render(
  <div>
  <Provider store={store}>
      <App />
    </Provider>
  </div>,
  document.getElementById('root')
);

//registerServiceWorker();
unregister();


// WEBPACK FOOTER //
// ./src/index.js